var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/sms-tracking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/sms-tracking_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-tracking"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34 42.5H14C13.18 42.5 12.5 41.82 12.5 41C12.5 40.18 13.18 39.5 14 39.5H34C39.72 39.5 42.5 36.72 42.5 31V17C42.5 11.28 39.72 8.5 34 8.5H14C8.28 8.5 5.5 11.28 5.5 17C5.5 17.82 4.82 18.5 4 18.5C3.18 18.5 2.5 17.82 2.5 17C2.5 9.7 6.7 5.5 14 5.5H34C41.3 5.5 45.5 9.7 45.5 17V31C45.5 38.3 41.3 42.5 34 42.5Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9996 25.7399C22.3196 25.7399 20.6196 25.2199 19.3196 24.1599L13.0596 19.1599C12.4196 18.6399 12.2996 17.6999 12.8196 17.0599C13.3396 16.4199 14.2795 16.2999 14.9195 16.8199L21.1795 21.8199C22.6995 23.0399 25.2795 23.0399 26.7995 21.8199L33.0596 16.8199C33.6996 16.2999 34.6595 16.3999 35.1595 17.0599C35.6795 17.6999 35.5795 18.6599 34.9195 19.1599L28.6595 24.1599C27.3795 25.2199 25.6796 25.7399 23.9996 25.7399Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 34.5H4C3.18 34.5 2.5 33.82 2.5 33C2.5 32.18 3.18 31.5 4 31.5H16C16.82 31.5 17.5 32.18 17.5 33C17.5 33.82 16.82 34.5 16 34.5Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 26.5H4C3.18 26.5 2.5 25.82 2.5 25C2.5 24.18 3.18 23.5 4 23.5H10C10.82 23.5 11.5 24.18 11.5 25C11.5 25.82 10.82 26.5 10 26.5Z",
    fill: "#777777"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.cba8a7439b7ac579c3acbc3a74c27ee9.svg";
export { ForwardRef as ReactComponent };